module.exports = __webpack_public_path__ + "img/headLeft5.4b06374f.png";